module.exports = __webpack_public_path__ + "static/media/carousel_cheese_3.819cf2db.jpg";